
<div id="verticalBarChartTwo" style="width:100%;height:400px;"></div>
